module.exports = __webpack_public_path__ + "static/media/male3.fd76715f.png";